exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.help_0 {\n  margin-top:10px;\n  margin-bottom:-10px;\n  padding-top:5px;\n  padding-bottom:5px;\n  border-top:1px solid #E5E5E5;\n  color:#8B7B8B;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a73c79b6","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ticket/TicketTemplateSelect.vue
// module id = 771
// module chunks = 75